import { createCloudRunAxios } from './axios';
import { useOrganizationStore } from '../stores/useOrganizationStore';

const remiApi = createCloudRunAxios('remi-api');

export interface VoiceSampleRequest {
  voice_id: string;
  text?: string;
  language?: string;
  organization_id?: string;
}

/**
 * Generate a voice sample via Remi API.
 * Returns a Blob containing WAV audio data.
 */
export const generateVoiceSample = async (
  voiceId: string,
  text?: string,
  language?: string
): Promise<Blob> => {
  const organizationId = useOrganizationStore.getState().organization?.id ?? '';

  const payload: VoiceSampleRequest = {
    voice_id: voiceId,
    organization_id: organizationId,
  };

  if (text) payload.text = text;
  if (language) payload.language = language;

  const response = await remiApi.post('/api/v1/voice-sample-generator', payload, {
    responseType: 'blob',
  });
  return response.data;
};
